import axios from 'axios'
// import $ from 'jquery'
//

// axios全局配置
axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = '/api/'

// 添加请求拦截器，POST传参序列化
axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    config.data = JSON.stringify(config.data)
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 添加响应拦截器,返回状态判断
axios.interceptors.response.use((res) => {
  return res
}, (error) => {
  return Promise.reject(error)
})

export function fetch (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
    // $.ajax({
    //   url:'http://172.16.20.19:12683/addRecruiter',
    //   type:'POST',
    //   contentType: 'application/json;charset=UTF-8',
    //   data:JSON.stringify(params),
    //   success:function(data){
    //     console.log(data);
    //   },
    //   error:function(error){
    //     console.log(error)
    //   }
    // })
  })
}

export default {
  addRecruiter (params) {
    return fetch('/addRecruiter', params)
  },
  listRecruitRecord (params) {
    return fetch('/listRecruitRecord', params)
  }
}



// WEBPACK FOOTER //
// ./src/config/api.js